//remove lang sites after migrated to AEM, keep sub sites
export default [
    "citrixready.citrix.com",
    "www.citrix.com",
    "www.citrix.co.jp",
    "www.citrix.com.cn",
    "www.citrix.se",
    "www.citrix.no",
    "www.citrix.fi",
    "www.citrix.dk",
    "www.citrix.cz",
    "www.citrix.com.pl",
    "www.citrix.com.tr",
    "www.sharefile.com"
]